import React, { SVGProps } from "react";
import Icon from "./Icon/Icon";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 15.7 15.7"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="m2.9 7.8.7-.7L6.5 10l5.2-5.2.7.7-5.9 5.9zm5 7.9C3.5 15.7 0 12.2 0 7.9S3.5 0 7.9 0s7.9 3.5 7.9 7.9c-.1 4.3-3.6 7.8-7.9 7.8M7.9 1C4.1 1 1 4.1 1 7.9s3.1 6.9 6.9 6.9 6.9-3.1 6.9-6.9C14.7 4.1 11.7 1 7.9 1" />
  </svg>
);
const SvgCheckmarkCircle = (
  props: Omit<React.ComponentProps<typeof Icon>, "SvgIcon" | "name">
) => <Icon SvgIcon={SvgIcon} name="checkmark-circle" {...props} />;
export default SvgCheckmarkCircle;
